import type { DataLayer } from '@/global';

export const dataLayerPush = (data: Partial<DataLayer>) => {
  if (typeof window.dataLayer !== 'undefined')
    window.dataLayer.push(data);
};
